


import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LottieNavigation.css";

export default function OverlayButton() {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer); // cleanup if component unmounts
  }, []);

  return (
    <>
      {showButton && (
        <button onClick={() => navigate("/home")} className="overlay-button fade-in">
          TOUCH TO START
        </button>
      )}
    </>
  );
}
